import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      // HomeRedirect at "/" will route to /dashboard or /subscribe based on subscription_status
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1585662127988-d44a2e747094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzYWdlJTIwbGVhZiUyMGFic3RyYWN0JTIwY2FsbWluZ3xlbnwwfHx8fDE3NzgwMzE4MjR8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-sage/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="font-display text-3xl mb-2 drop-shadow">Bon retour parmi nous.</div>
          <p className="text-white/90 max-w-md drop-shadow">Votre cabinet vous attend, prêt à vous accompagner.</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-10" style={{ backgroundColor: "var(--bg)" }}>
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-3 mb-10" data-testid="login-brand">
            <div className="w-10 h-10 rounded-2xl bg-sage flex items-center justify-center">
              <Leaf className="w-5 h-5 text-white" strokeWidth={1.6} />
            </div>
            <div>
              <div className="font-display">Mon Cabinet Bien-être</div>
              <div className="text-xs text-muted-soft">by Capsule Patrimoine</div>
            </div>
          </Link>

          <h1 className="font-display text-3xl mb-2">Connexion</h1>
          <p className="text-muted-soft mb-8">Heureuse de vous revoir.</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-sm font-medium block mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vous@cabinet.fr"
                className="input-soft"
              />
            </div>
            <div>
              <label className="text-sm font-medium block mb-2">Mot de passe</label>
              <input
                data-testid="login-password"
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="input-soft"
              />
            </div>

            {error && (
              <div className="text-sm rounded-xl px-4 py-3" style={{ backgroundColor: "#FBEEE8", color: "#8B4D3D" }} data-testid="login-error">
                {error}
              </div>
            )}

            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-sage w-full text-base py-3.5">
              {loading ? "Connexion…" : "Me connecter"}
            </button>
          </form>

          <div className="text-sm text-muted-soft mt-8 text-center">
            Nouveau ici ? <Link to="/register" className="text-sage font-medium hover:underline" data-testid="link-register">Créer un compte</Link>
            <div className="mt-2">
              <Link to="/forgot-password" className="text-xs text-muted-soft hover:text-sage" data-testid="link-forgot">Mot de passe oublié ?</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
